<template>
    <the-content>
        <div class="heading">
            <div class="heading-nav">
                <v-btn :to="{name: 'clients.list'}" text fab small exact>
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
            </div>
            <h1 class="heading-title">Новый клиент</h1>
        </div>

        <ValidationObserver ref="form" v-slot="{ passes }" tag="div">
            <v-form @submit.prevent="passes(onSubmit)">
                <v-card class="client-card" :class="{'view-xs': $vuetify.breakpoint.xsOnly}">
                    <v-card-text class="pa-6">
                        <v-row>
                            <v-col cols="12" sm="6" md="4" lg="4" class="client-photo-col">
                                <!-- photo start -->
                                <div class="client-photo">
                                    <div class="client-photo-wrap">
                                        <template v-if="photo && originalPhoto">
                                            <edit-photo
                                                    v-if="editPhoto"
                                                    :src="originalPhoto"
                                                    @input="photo=$event"
                                                    @cancel="editPhoto=false"
                                            />
                                            <template v-else>
                                                <div class="client-photo-image"
                                                     :style="{backgroundImage: photo ? `url(${photo})` : ''}"></div>
                                                <div class="client-photo-actions">
                                                    <v-btn @click.prevent="editPhoto=true" color="primary" small fab
                                                           class="mx-4">
                                                        <v-icon>mdi-pencil</v-icon>
                                                    </v-btn>
                                                    <v-btn @click.prevent="resetPhoto" color="error" small fab
                                                           class="mx-4">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <webcam-photo v-if="webcam" @input="setPhoto" @close="resetPhoto"/>
                                            <div v-else class="client-photo-add" @click.prevent="webcam=true">
                                                <v-icon>mdi-plus</v-icon>
                                                Добавить фото
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <!-- photo end -->
                            </v-col>
                            <v-col cols="12" sm="6" md="8" lg="8" class="pt-0">
                                <!-- information start -->
                                <div class="client-info">
                                    <v-row>
                                        <v-col cols="12" class="pb-0" md="6">
                                            <ValidationProvider name="name"
                                                                rules="required"
                                                                v-slot="{ errors }"
                                                                tag="div"
                                                                class="client-info-group">
                                                <v-text-field
                                                        type="text"
                                                        v-model="name"
                                                        label="Ф.И.О."
                                                        :error-messages="errors"
                                                        required
                                                        outlined
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" class="pb-0" md="6">
                                            <ValidationProvider name="phone" rules="required" v-slot="{ errors }"
                                                                tag="div"
                                                                class="client-info-group">
                                                <div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--single-line v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
                                                     :class="{'error--text': errors.length, 'v-input--has-state': errors.length, 'v-input--is-focused primary--text': telFocused}"
                                                >
                                                    <div class="v-input__control">
                                                        <div class="v-input__slot" @click.stop="telFocus">
                                                            <fieldset aria-hidden="true"><legend style="width: 55px;"><span></span></legend></fieldset>
                                                            <div class="v-text-field__slot">
                                                                <label for="input-tel"
                                                                       class="v-label v-label--active theme--light"
                                                                       :class="{'error--text': errors.length}"
                                                                       style="left: 0; right: auto; position: absolute;">Телефон</label>
                                                                <vue-tel-input
                                                                        id="input-tel"
                                                                        v-model="phone"
                                                                        :dynamicPlaceholder="true"
                                                                        :enabledCountryCode="false"
                                                                        :disabledFormatting="true"
                                                                        :preferredCountries="['BY', 'RU']"
                                                                        defaultCountry="BY"
                                                                        :disabledFetchingCountry="true"
                                                                        :validCharactersOnly="true"
                                                                        :inputOptions="{showDialCode: false}"
                                                                        mode="international"
                                                                        autocomplete="off"
                                                                        required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="v-text-field__details">
                                                            <div class="v-messages theme--light"
                                                                 :class="{'error--text': errors.length}">
                                                                <div class="v-messages__wrapper">
                                                                    <div class="v-messages__message"
                                                                         v-if="errors.length">{{
                                                                        errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" class="pb-0" md="6">
                                            <ValidationProvider name="gender"
                                                                v-slot="{ errors }"
                                                                tag="div"
                                                                class="client-info-group"
                                            >
                                                <v-select
                                                        :items="[{title: 'мужчина', value: $constants.GENDER_MALE}, {title:'женщина',value: $constants.GENDER_FEMALE}]"
                                                        v-model="gender"
                                                        item-text="title"
                                                        item-value="value"
                                                        label="Пол"
                                                        :error-messages="errors"
                                                        outlined
                                                        hint="Необязательно"
                                                        persistent-hint
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" class="pb-0" md="6">
                                            <ValidationProvider name="bday"
                                                                v-slot="{ errors }"
                                                                tag="div"
                                                                class="client-info-group">
                                                <v-menu
                                                        v-model="bdayPicker"
                                                        :close-on-content-click="false"
                                                        :nudge-right="33"
                                                        :nudge-top="25"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                >
                                                    <template v-slot:activator="{on}">
                                                        <v-text-field
                                                                v-model="bdayFormatted"
                                                                @blur="bday = parseDate(bdayFormatted)"
                                                                label="Дата рождения ДД.ММ.ГГГГ"
                                                                v-mask="'##.##.####'"
                                                                required
                                                                clearable
                                                                v-on="on"
                                                                outlined
                                                                :error-messages="errors"
                                                                hint="Необязательно"
                                                                persistent-hint
                                                        />
                                                    </template>
                                                    <v-date-picker
                                                            ref="bdayPicker"
                                                            v-model="bday"
                                                            locale="ru-RU"
                                                            @input="onBdayPickerInput"
                                                            first-day-of-week="1"
                                                            :max="new Date().toISOString().substr(0, 10)"
                                                            min="1950-01-01"
                                                    />
                                                </v-menu>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" class="pb-0">
                                            <ValidationProvider name="notes"
                                                                v-slot="{ errors }"
                                                                tag="div"
                                                                class="client-info-group">
                                                <v-textarea
                                                        name="notes"
                                                        label="Заметки"
                                                        v-model="notes"
                                                        auto-grow
                                                        clearable
                                                        outlined
                                                        :error-messages="errors"
                                                        hint="Необязательно"
                                                        persistent-hint
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                    </v-row>
                                </div>
                                <!-- information end -->
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <div class="client-actions mt-8 text-center">
                    <v-btn :to="{name: 'clients.list'}" exact dark color="blue-grey" min-width="200" class="ma-2">
                        Отмена
                    </v-btn>
                    <v-btn type="submit" color="success" min-width="200" class="ma-2">Создать</v-btn>
                </div>
            </v-form>
        </ValidationObserver>
    </the-content>
</template>

<script>
    import {VueTelInput} from 'vue-tel-input';
    import {mask} from 'vue-the-mask';
    import dayjs from 'dayjs';

    export default {
        name      : "ClientAddPage",
        components: {VueTelInput},
        directives: {
            mask,
        },
        data() {
            return {
                name  : '',
                phone : '',
                gender: '',
                bday  : '',
                notes : '',

                photo        : '',
                originalPhoto: '',
                editPhoto    : false,
                webcam       : false,

                bdayPicker: false,

                telFocused   : false,
                bdayFormatted: '',
            }
        },
        watch     : {
            bdayPicker(val) {
                val && setTimeout(() => (this.$refs.bdayPicker.activePicker = 'YEAR'));
            }
        },
        created() {
            window.addEventListener('click', this.telBlur);
        },
        methods   : {
            onSubmit() {
                this.$store.dispatch('clients/add', {
                    name  : this.name,
                    phone : this.phone,
                    photo : this.photo,
                    gender: this.gender,
                    bday  : this.bday,
                    notes : this.notes,
                }).then(({data}) => {
                    this.$router.push({name: 'clients.show', params: {clientId: data.data.id}});
                }).catch(({response}) => {
                    // process errors
                    this.$refs.form.setErrors(response.data.errors);
                })
            },
            resetPhoto() {
                this.webcam = false;
                this.photo = '';
                this.originalPhoto = '';
            },
            setPhoto(newPhoto) {
                this.webcam = false;
                this.photo = newPhoto;
                this.originalPhoto = newPhoto;
                this.editPhoto = true;
            },
            telFocus() {
                this.telFocused = true;
            },
            telBlur() {
                this.telFocused = false;
            },
            parseDate(date) {
                if (!date) return null;

                return dayjs(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
            },
            formatDate(date) {
                if (!date) return null;

                return dayjs(date, 'YYYY-MM-DD').format("DD.MM.YYYY");
            },
            onBdayPickerInput() {
                this.bdayPicker = false;
                this.bdayFormatted = this.formatDate(this.bday);
            }
        }
    }
</script>

<style scoped>

</style>
